export default {
  popupHidden: false
};
